import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BirdGrid from "./BirdGrid";
import "./Home.css";
import aboutBird from "../images/about-bird.jpg";
import birdWatching from "../images/bird-watching.jpg";
import educational from "../images/educational.jpg";
import photography from "../images/photography.jpeg";

function Home() {
  const navigate = useNavigate();

  // State for comments
  const [comments, setComments] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  // Fetch comments from backend
  useEffect(() => {
    fetch("http://localhost:5000/api/comments")
      .then((res) => res.json())
      .then((data) => setComments(data || [])) // safe handling
      .catch((err) => console.error(err));
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Add new comment to backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.message.trim()) return;

    try {
      const res = await fetch("http://localhost:5000/api/comments", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const newComment = await res.json();
      setComments([newComment, ...comments]);
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      console.error(err);
    }
  };

  // Like comment
  const handleLike = async (id) => {
    try {
      const res = await fetch(`http://localhost:5000/api/comments/like/${id}`, {
        method: "PUT",
      });
      const updatedComment = await res.json();
      setComments(comments.map((c) => (c._id === id ? updatedComment : c)));
    } catch (err) {
      console.error(err);
    }
  };

  // Reply to comment
  const handleReply = async (id, replyMessage) => {
    if (!replyMessage.trim()) return;
    try {
      const res = await fetch(`http://localhost:5000/api/comments/reply/${id}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: "Guest", message: replyMessage }),
      });
      const updatedComment = await res.json();
      setComments(comments.map((c) => (c._id === id ? updatedComment : c)));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section id="home" className="hero-section">
        <h2>Welcome to Birds Paradise</h2>
        <p>Discover beautiful birds from around the world.</p>
        <BirdGrid />
      </section>

      {/* About Section */}
      <section id="about" className="about-section">
        <div className="about-content">
          <div className="about-text">
            <h2>About Us</h2>
            <p>
              At <strong>Birds Paradise</strong>, we are passionate about
              celebrating the beauty of nature through birds. Our mission is to
              educate and inspire people about the diversity and wonder of
              birdlife worldwide. Whether you're a casual bird lover or a
              dedicated birdwatcher, we aim to provide insightful articles,
              photography, and guides that deepen your connection with these
              magnificent creatures.
            </p>
            <p>
              Join our global community of bird enthusiasts, share your
              experiences, and explore the incredible variety of species that
              make our planet so vibrant.
            </p>
          </div>
          <div className="about-image">
            <img src={aboutBird} alt="About Birds Paradise" />
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services-section">
        <h2>Our Services</h2>
        <div className="services-container">
          <div className="service-card" onClick={() => navigate("/service1")}>
            <img src={birdWatching} alt="Bird Watching Guides" />
            <h3>Bird Watching Guides</h3>
            <button onClick={() => navigate("/service1")}>Explore</button>
          </div>

          <div className="service-card" onClick={() => navigate("/service2")}>
            <img src={educational} alt="Educational Articles" />
            <h3>Educational Articles</h3>
            <button onClick={() => navigate("/service2")}>Explore</button>
          </div>

          <div className="service-card" onClick={() => navigate("/service3")}>
            <img src={photography} alt="Bird Photography Gallery" />
            <h3>Bird Photography Gallery</h3>
            <button onClick={() => navigate("/service3")}>Explore</button>
          </div>
        </div>
      </section>

      {/* Comments Section */}
      <section id="comments" className="comments-section">
        <h2>Community Comments</h2>

        <form className="comment-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email (optional)"
            value={formData.email}
            onChange={handleChange}
          />
          <textarea
            name="message"
            placeholder="Write your comment..."
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit">Post Comment</button>
        </form>

        <div className="comment-list">
          {(comments || []).length === 0 ? (
            <p className="no-comments">No comments yet. Be the first!</p>
          ) : (
            (comments || []).map((c) => (
              <div key={c._id || c.id} className="comment">
                <div className="comment-header">
                  <div className="avatar">{(c.name || "U").charAt(0).toUpperCase()}</div>
                  <div>
                    <h4>{c.name}</h4>
                    <small>{new Date(c.date).toLocaleString()}</small>
                  </div>
                </div>

                <p className="comment-text">{c.message}</p>

                <div className="comment-actions">
                  <button onClick={() => handleLike(c._id || c.id)}>👍 {c.likes || 0}</button>
                </div>

                <ReplyBox onReply={(msg) => handleReply(c._id || c.id, msg)} />

                {(c.replies || []).length > 0 && (
                  <div className="replies">
                    {(c.replies || []).map((r) => (
                      <div key={r._id || r.id} className="reply">
                        <strong>{r.name}</strong>: {r.message}
                        <small>{new Date(r.date).toLocaleString()}</small>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </section>
    </div>
  );
}

function ReplyBox({ onReply }) {
  const [reply, setReply] = useState("");
  return (
    <div className="reply-box">
      <textarea
        value={reply}
        onChange={(e) => setReply(e.target.value)}
        placeholder="Write a reply..."
      />
      <button
        onClick={() => {
          onReply(reply);
          setReply("");
        }}
      >
        Reply
      </button>
    </div>
  );
}

export default Home;
